import React from "react";
import { ContextConsumer } from "./MyContext";
import httpclient from "../../httpclient";

export const getUserAuthorizations = async () => {
  let url = process.env.REACT_APP_BASE_API_URL + "permissions/myPermissions";

  return await httpclient
    .GET(url)
    .then((res) => {
      let user_authorizations = res.data.data;
      return user_authorizations;
    })
    .catch((error) => {
      console.log(error);
      return {};
    });
};

export const CanAccess = ({ role, yes, no }) => {
  return (
    <ContextConsumer>
      {(context) => {
        let { user_authorizations } = context;
        let mode = "";
        if (Array.isArray(role)) {
          for (let i = 0; i < role.length; i++) {
            if (role[i] in user_authorizations) {
              if (user_authorizations[role[i]]) {
                mode = "yes";
                break;
              } else mode = "no";
            }
            if (role[i] === "no_role") {
              mode = "yes";
              break;
            }
          }
        }
        if (role in user_authorizations) {
          if (user_authorizations[role]) mode = "yes";
          else mode = "no";
        }
        if (mode === "yes" || role === "no_role") return yes;
        else if (mode === "no") return no;
      }}
    </ContextConsumer>
  );
};

export const AuthorizationList = {
  view_permission: "view_permission",
  update_permission: "update_permission",

  view_role: "view_role",
  create_role: "create_role",
  update_role: "update_role",
  delete_role: "delete_role",

  view_user: "view_user",
  create_user: "create_user",
  update_user: "update_user",
  delete_user: "delete_user",

  view_outlet: "view_outlet",
  create_outlet: "create_outlet",
  update_outlet: "update_outlet",
  delete_outlet: "delete_outlet",

  view_employee: "view_employee",
  create_employee: "create_employee",
  update_employee: "update_employee",
  delete_employee: "delete_employee",

  view_jabatan: "view_jabatan",
  create_jabatan: "create_jabatan",
  update_jabatan: "update_jabatan",
  delete_jabatan: "delete_jabatan",

  view_storage: "view_storage",
  create_storage: "create_storage",
  update_storage: "update_storage",
  delete_storage: "delete_storage",

  view_midtrans: "view_midtrans",

  view_customer: "view_customer",

  view_shelf: "view_shelf",
  create_shelf: "create_shelf",
  update_shelf: "update_shelf",
  delete_shelf: "delete_shelf",

  view_product: "view_product",
  create_product: "create_product",
  update_product: "update_product",
  delete_product: "delete_product",

  view_campaign: "view_campaign",
  create_campaign: "create_campaign",
  update_campaign: "update_campaign",
  delete_campaign: "delete_campaign",

  view_label: "view_label",
  create_label: "create_label",
  print_label: "print_label",

  view_outlet_cash: "view_outlet_cash",
  update_outlet_cash: "update_outlet_cash",

  view_report_gadai: "view_report_gadai",
  view_report_refund: "view_report_refund",
  create_report_refund: "create_report_refund",
  update_report_refund: "update_report_refund",
  delete_report_refund: "delete_report_refund",
  view_report_failed_gadai: "view_report_failed_gadai",
  print_report_failed_gadai: "print_report_failed_gadai",

  create_failed_gadai_offer: "create_failed_gadai_offer",
  view_transaction_gadai: "view_transaction_gadai",
  print_transaction_gadai: "print_transaction_gadai",
  view_transaction_outlet_cash: "view_transaction_outlet_cash",
  print_transaction_outlet_cash: "print_transaction_outlet_cash",
  view_waiting_disburse: "view_waiting_disburse",
  delete_waiting_disburse: "delete_waiting_disburse",
  view_waiting_payment: "view_waiting_payment",
  delete_waiting_payment: "delete_waiting_payment",
  view_point_disbursement: "view_point_disbursement",
  view_top_up_deposit: "view_top_up_deposit",
  view_debit_card: "view_debit_card",

  view_area: "view_area",
  create_area: "create_area",
  update_area: "update_area",
  delete_area: "delete_area",

  view_jemput_gadai: "view_jemput_gadai",
  create_jemput_gadai: "create_jemput_gadai",
  update_jemput_gadai: "update_jemput_gadai",
  delete_jemput_gadai: "delete_jemput_gadai",
  update_pick_up_gadai: "update_pick_up_gadai",

  view_history_delivery_gadai: "view_history_delivery_gadai",
  view_scheduled_delivery_gadai: "view_scheduled_delivery_gadai",
  view_sheduled_pick_up_gadai: "view_sheduled_pick_up_gadai",
  view_pick_up_gadai: "view_pick_up_gadai",
  view_delivery_gadai: "view_delivery_gadai",
  update_delivery_gadai: "update_delivery_gadai",
  update_scheduled_delivery_gadai: "update_scheduled_delivery_gadai",

  view_appraiser: "view_appraiser",
  save_appraiser: "save_appraiser",
  delete_appraiser: "delete_appraiser",
  view_outlet_appraiser: "view_outlet_appraiser",
  save_outlet_appraiser: "save_outlet_appraiser",
  delete_outlet_appraiser: "delete_outlet_appraiser",

  view_gadai_exclusive: "view_gadai_exclusive",
  create_gadai_exclusive: "create_gadai_exclusive",
  cancel_gadai_exclusive: "cancel_gadai_exclusive",

  create_regular_offer: "create_regular_offer",
  view_regular_offer: "view_regular_offer",
  update_regular_offer: "update_regular_offer",
  create_promo_offer: "create_promo_offer",
  view_promo_offer: "view_promo_offer",
  update_promo_offer: "update_promo_offer",
  delete_promo_offer: "delete_promo_offer",
  create_regular_extension_offer: "create_regular_extension_offer",
  view_regular_extension_offer: "view_regular_extension_offer",
  update_regular_extension_offer: "update_regular_extension_offer",
  create_promo_extension_offer: "create_promo_extension_offer",
  update_promo_extension_offer: "update_promo_extension_offer",
  view_promo_extension_offer: "view_promo_extension_offer",
  delete_promo_extension_offer: "delete_promo_extension_offer",
  view_gadai: "view_gadai",
  update_waiting_disburse: "update_waiting_disburse",
  update_top_up_deposit: "update_top_up_deposit",
  update_refund: "update_refund",
  update_report_refund: "update_report_refund",
  update_report_failed_gadai: "update_report_failed_gadai",
  create_appraiser: "create_appraiser",
  create_outlet_appraiser: "create_outlet_appraiser",
  view_company_setting: "view_company_setting",
  update_company_setting: "update_company_setting",
  create_customer_commission: "create_customer_commission",
  view_customer_membership_settings: "view_customer_membership_settings",
  update_customer_membership_settings: "update_customer_membership_settings",
  view_bank: "view_bank",
  create_bank: "create_bank",
  update_bank: "update_bank",
  delete_bank: "delete_bank",
  view_customer_commission: "view_customer_commission",
  update_midtrans: "update_midtrans",
  view_refund: "view_refund",
  view_manual_transfer: "view_manual_transfer",
  update_manual_transfer: "update_manual_transfer",
  no_role: "no_role",
  view_notification_group: "view_notification_group",
  create_notification_group: "create_notification_group",
  update_notification_group: "update_notification_group",
  delete_notification_group: "delete_notification_group",
};
